import React, { useState, useEffect, useRef } from 'react'

export default function AnimatedStat({ value, label }) {
  const [displayValue, setDisplayValue] = useState(0)
  const [hasAnimated, setHasAnimated] = useState(false)
  const ref = useRef(null)

  // Extract numeric target and suffix/prefix (e.g., "2014" -> 2014, "35+" -> 35, "+", "100%" -> 100, "%")
  const numericMatch = String(value).match(/^(\d+)(.*)$/)
  const target = numericMatch ? parseInt(numericMatch[1], 10) : 0
  const suffix = numericMatch ? numericMatch[2] : ''

  useEffect(() => {
    const node = ref.current
    if (!node) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true)
          let startTimestamp = null
          const duration = 1600 // ms

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp
            const progress = Math.min((timestamp - startTimestamp) / duration, 1)
            // Cubic ease-out function
            const easeOut = 1 - Math.pow(1 - progress, 3)
            setDisplayValue(Math.floor(easeOut * target))
            if (progress < 1) {
              window.requestAnimationFrame(step)
            } else {
              setDisplayValue(target)
            }
          }
          window.requestAnimationFrame(step)
        }
      },
      { threshold: 0.2 }
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [target, hasAnimated])

  return (
    <div ref={ref} className="bg-slate-950 p-4 rounded-2xl border border-slate-800 text-center shadow-lg">
      <div className="font-heading font-black text-2xl sm:text-3xl text-cyan-400">
        {displayValue}
        {suffix}
      </div>
      <div className="text-xs text-slate-400 font-medium mt-1">{label}</div>
    </div>
  )
}
